// src/screens/NuevoVehiculoScreen.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoCarSportOutline } from 'react-icons/io5';
import './NuevoVehiculoScreen.css'; // Premium Styles

import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

function NuevoVehiculoScreen() {
  const navigate = useNavigate();
  const { currentUser, userData } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Estados del formulario
  const [marca, setMarca] = useState('');
  const [modelo, setModelo] = useState('');
  const [placas, setPlacas] = useState('');
  const [color, setColor] = useState('');
  const [anio, setAnio] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!marca || !placas) {
      setError("La Marca y las Placas son obligatorias.");
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Preparamos el nuevo documento
      const nuevoVehiculo = {
        marca: marca,
        modelo: modelo,
        placas: placas.toUpperCase(), // Guardar placas en mayúsculas
        color: color,
        anio: anio,

        // Datos de sistema
        residenteId: currentUser.uid,
        condominioId: userData.condominioId,
        fechaRegistro: Timestamp.now(),
        estatus: "pendiente", // ¡El estado inicial!
        tagId: "" // Vacío hasta que el admin lo asigne
      };

      // Guardamos en la nueva colección "vehiculos"
      await addDoc(collection(db, "vehiculos"), nuevoVehiculo);

      alert("¡Vehículo registrado con éxito! Queda pendiente de validación por la administración.");
      navigate('/vehiculos');

    } catch (e) {
      console.error("Error al registrar vehículo: ", e);
      setError("Error al guardar el vehículo. Intente nuevamente.");
      setLoading(false);
    }
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/vehiculos" />
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>
        <div className="ks-scroll-area">
          <div className="nuevo-vehiculo-container">
            {/* Sticky Compact Header */}
            <div className="nuevo-vehiculo-fixed-wrapper">
              <div className="nuevo-vehiculo-banner-compact">
                <button onClick={() => navigate('/vehiculos')} className="nuevo-vehiculo-back-btn glass">
                  <IoArrowBack size={24} />
                </button>

                <div className="nuevo-vehiculo-banner-content">
                  <h2>Registrar Vehículo</h2>
                  <p>Acceso automatizado</p>
                </div>

                <div className="nuevo-vehiculo-banner-icon">
                  <IoCarSportOutline />
                </div>
              </div>
            </div>

            {/* Form Card */}
            <div className="nuevo-vehiculo-form-card">
              <form onSubmit={handleSubmit}>

                {error && <div className="form-error-msg">{error}</div>}

                <div className="form-group-premium">
                  <label className="form-label-premium">Marca (Ej. Nissan)</label>
                  <input
                    type="text"
                    value={marca}
                    onChange={(e) => setMarca(e.target.value)}
                    className="form-input-premium"
                    placeholder="Ingresa la marca"
                    required
                  />
                </div>

                <div className="form-group-premium">
                  <label className="form-label-premium">Modelo (Ej. Versa)</label>
                  <input
                    type="text"
                    value={modelo}
                    onChange={(e) => setModelo(e.target.value)}
                    className="form-input-premium"
                    placeholder="Ingresa el modelo"
                  />
                </div>

                <div className="form-group-premium">
                  <label className="form-label-premium">Placas (Ej. ABC-123)</label>
                  <input
                    type="text"
                    value={placas}
                    onChange={(e) => setPlacas(e.target.value)}
                    className="form-input-premium"
                    placeholder="Placas del vehículo"
                    required
                  />
                </div>

                <div className="form-group-premium" style={{ display: 'flex', gap: '20px' }}>
                  <div style={{ flex: 1 }}>
                    <label className="form-label-premium">Color</label>
                    <input
                      type="text"
                      value={color}
                      onChange={(e) => setColor(e.target.value)}
                      className="form-input-premium"
                      placeholder="Ej. Rojo"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label-premium">Año</label>
                    <input
                      type="number"
                      value={anio}
                      onChange={(e) => setAnio(e.target.value)}
                      className="form-input-premium"
                      placeholder="Ej. 2023"
                    />
                  </div>
                </div>

                <button type="submit" className="form-submit-btn" disabled={loading}>
                  {loading ? 'Procesando...' : 'Guardar Vehículo'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <KondoBottomNav activeRoute="/vehiculos" />
      </main>
    </div>
  );
}

export default NuevoVehiculoScreen;